export const trackingName = courier => `${courier.firstName || ""} ${courier.lastName || ""}`.trim();

export function trackingState(courier, now) {
    if (!courier.eligible || courier.trackingEnded) return {state: "ended", location: null};
    const location = courier.tracking && courier.location;
    if (!location) return {state: "none", location: null};
    const captured = Date.parse(location.capturedAt);
    // Defaults support a rolling deployment of PO-565; new servers supply configured deadlines.
    const staleAt = Date.parse(location.staleAt) || captured + 120000;
    const expiresAt = Date.parse(location.expiresAt) || captured + 86400000;
    if (now >= expiresAt) return {state: "expired", location: null};
    const valid = Number.isFinite(captured) && Number.isFinite(location.latitude) && Math.abs(location.latitude) <= 90
        && Number.isFinite(location.longitude) && Math.abs(location.longitude) <= 180
        && Number.isFinite(location.accuracy) && location.accuracy >= 0;
    if (!valid) return {state: "none", location: null};
    return {state: location.stale || now >= staleAt ? "stale" : "fresh", location,
        age: Math.max(0, Math.floor((now - captured) / 1000)), poorAccuracy: location.accuracy > 100};
}

export const trackingStateLabel = state => ({fresh: "CourierMapFresh", stale: "CourierMapStale",
    none: "CourierMapNoLocation", ended: "CourierMapEnded", expired: "CourierMapExpired"})[state];

export function groupTrackingPoints(points) {
    const groups = new Map();
    points.filter(point => point.location).forEach(point => {
        const key = `${point.location.longitude}:${point.location.latitude}`;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(point);
    });
    return [...groups.values()];
}
